// Campus photo for /colleges/florida-international-university: CC BY-SA 2.0, by Eduardo Merille, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AEastward_view_of_FIU's_campus.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/florida-international-university/; credited under the photo.
const photo = {
    "slug": "florida-international-university",
    "alt": "A lake and footbridge on the Florida International University campus in Miami, with campus buildings rising behind the trees",
    "src": "/colleges/florida-international-university/campus-1600.webp",
    "srcSmall": "/colleges/florida-international-university/campus-800.webp",
    "srcMid": "/colleges/florida-international-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/florida-international-university/og.jpg",
    "title": "Eastward view of FIU's campus",
    "author": "Eduardo Merille",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AEastward_view_of_FIU's_campus.jpg",
    "read": "2026-10-01"
};

export default photo;
